import React from 'react';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import {
  MarkdownCodeBlockContainer,
  MarkdownCodeBody,
  MarkdownCodeCopyIcon,
  MarkdownCodeHeader,
  MarkdownCodeLine,
  MarkdownCodeLineNumber,
  MarkdownCodeLineText,
} from '../../../../Markdown/styles';

export function renderDocumentationCodeBlock(rawSourceText: string) {
  const sourceText = rawSourceText.replace(/\n$/, '');
  const sourceLines =
    sourceText.length > 0 ? sourceText.split('\n') : [''];

  return (
    <MarkdownCodeBlockContainer>
      <MarkdownCodeHeader>
        <MarkdownCodeCopyIcon>
          <FileCopyOutlinedIcon fontSize="small" />
        </MarkdownCodeCopyIcon>
      </MarkdownCodeHeader>
      <MarkdownCodeBody>
        {sourceLines.map((sourceLine, sourceLineIndex) => (
          <MarkdownCodeLine
            key={`${sourceLineIndex + 1}-${sourceLine}`}
          >
            <MarkdownCodeLineNumber>
              {sourceLineIndex + 1}
            </MarkdownCodeLineNumber>
            <MarkdownCodeLineText>{sourceLine}</MarkdownCodeLineText>
          </MarkdownCodeLine>
        ))}
      </MarkdownCodeBody>
    </MarkdownCodeBlockContainer>
  );
}
